import React from 'react';
import { Download } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#0b0014] to-[#1a0533]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Gain exposure to U.S. markets
          </h2>
          <p className="text-xl text-gray-400 mb-10">
            Access and trade tokenized stocks directly with Stocks Protocol.
          </p>
          
          <a 
            href="#" 
            className="inline-flex items-center gap-2 px-8 py-4 text-lg font-semibold text-white bg-[#7B61FF] hover:bg-[#6B4FFF] rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-purple-500/25"
          >
            <Download className="w-5 h-5" />
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
